import type { ReactNode } from "react";

import { Paper, ScrollArea, Stack } from "@mantine/core";

import { GradientHeader } from "@/panels/modules/panels/components/GradientHeader";

import styles from "./MainPanelTabContent.module.css";

interface TabContentPanelProps {
    children?: ReactNode;
    isMinimized?: boolean;
    isClosed?: boolean;
    onClose?: () => void;
    onMinimize?: () => void;
    title?: string;
    showHeader: boolean;
}

export const MainPanelTabContent = ({
    children,
    isMinimized,
    onClose,
    onMinimize,
    title,
    isClosed,
    showHeader,
}: TabContentPanelProps) => {
    return (
        <Paper
            radius={0}
            className={`${styles.tabContentPanel} ${isClosed ? styles.tabContentPanelClosed : styles.tabContentPanelOpen}`}
        >
            <Stack h={"100%"} gap={0}>
                {showHeader && (
                    <GradientHeader
                        title={title}
                        onClose={onClose}
                        onMinimize={onMinimize}
                        isMinimized={isMinimized}
                        isClosed={isClosed}
                    />
                )}

                <ScrollArea flex={1}>{children}</ScrollArea>
            </Stack>
        </Paper>
    );
};
